import { useParams } from 'react-router';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { DocDtmKad } from '../../docs/components/DocDtmKad';
import { ManagerMenu } from '../../manager/managermenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const PodaniKADDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { manager, apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager && manager?.modules?.podaniKad ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='RelatedApps'
          action='allow_manager_all'
        >
          <DocDtmKad docId={parseInt(id!, 10)} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PodaniKADDetailPage;
